import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { FaArrowRight, FaUsers, FaHandshake, FaChartLine, FaHeart } from "react-icons/fa";

export default function HomeMembership(props) {
    const appContext = useContext(AppContext);
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    const benefitsList = [
        {
            icon: <FaUsers size={26} />,
            title: "Join a Movement",
            desc: "Become part of a growing community dedicated to transforming lives across Tanzania."
        },
        {
            icon: <FaHandshake size={26} />,
            title: "Make an Impact",
            desc: "Directly contribute to poverty alleviation, education, and sustainable development initiatives."
        },
        {
            icon: <FaChartLine size={26} />,
            title: "Grow Together",
            desc: "Access exclusive training, networking opportunities, and leadership development programs."
        },
        {
            icon: <FaHeart size={26} />,
            title: "Empower Communities",
            desc: "Support vulnerable groups and help build resilient, self-reliant communities nationwide."
        }
    ];

    if (ready) {
        return (
            <section className="MainBodySection mwadeo-membership-wrapper position-relative">
                
                {/* Primary Color Overlay */}
                <div className="membership-overlay"></div>

                <div className="container position-relative z-index-2">
                    
                    {/* Header Block */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-12 col-lg-10">
                            <span className="membership-kicker text-uppercase font-semi-bold">
                                Become a Member
                            </span>
                            <h2 className="title-font-bold membership-main-heading">
                                Join Our Mission to <span>Transform Lives</span>
                            </h2>
                            <p className="font-regular membership-subtext">
                                Together, we can lift the standard of living for the poor and build a prosperous, 
                                productive community. Your membership directly fuels sustainable change across Tanzania.
                            </p>
                        </div>
                    </div>

                    {/* Benefits Grid */}
                    <div className="membership-benefits">
                        {benefitsList.map((benefit, idx) => (
                            <div className="benefit-card" key={idx}>
                                <div className="benefit-icon">
                                    {benefit.icon}
                                </div>
                                <h4 className="title-font-bold benefit-title">
                                    {benefit.title}
                                </h4>
                                <p className="font-regular benefit-desc mb-0">
                                    {benefit.desc}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* CTA Button */}
                    <div className="text-center">
                        <button 
                            className="btn btn-mwadeo-membership title-font-semi-bold"
                            onClick={() => appContext.navTo({ item: 'membership' })}
                        >
                            <span>Become a Member Today</span>
                            <FaArrowRight size={18} />
                        </button>
                    </div>

                </div>
            </section>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "450px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}